import { ApplicationInsights, SeverityLevel } from '@microsoft/applicationinsights-web';
var AppInsightsWebLogger = /** @class */ (function () {
    function AppInsightsWebLogger(appKey, clientId) {
        this.$name = 'app-insights-web-logger';
        this._initializeApplicationInsights(appKey, clientId);
    }
    AppInsightsWebLogger.prototype.error = function (obj) {
        var properties = this._createProperties(obj);
        if (AppInsightsWebLogger._appInsights) {
            AppInsightsWebLogger._appInsights.trackException({
                exception: obj.error,
                severityLevel: SeverityLevel.Critical
            }, properties);
        }
    };
    AppInsightsWebLogger.prototype.debug = function (obj) {
        var properties = this._createProperties(obj);
        if (AppInsightsWebLogger._appInsights) {
            AppInsightsWebLogger._appInsights.trackTrace({
                message: obj.message || "<no message>",
                severityLevel: SeverityLevel.Verbose
            }, {
                properties: properties
            });
        }
    };
    AppInsightsWebLogger.prototype._initializeApplicationInsights = function (appKey, clientId) {
        if (!AppInsightsWebLogger._appInsights) {
            AppInsightsWebLogger._appInsights = new ApplicationInsights({
                config: {
                    instrumentationKey: appKey
                }
            });
            AppInsightsWebLogger._appInsights.loadAppInsights();
            var telemetryInitializer = function (envelope) {
                envelope.data.clientId = clientId;
            };
            AppInsightsWebLogger._appInsights.addTelemetryInitializer(telemetryInitializer);
            AppInsightsWebLogger._appInsights.trackPageView();
        }
    };
    AppInsightsWebLogger.prototype.info = function (obj) {
        var properties = this._createProperties(obj);
        if (AppInsightsWebLogger._appInsights) {
            AppInsightsWebLogger._appInsights.trackTrace({
                message: obj.message || "<no message>",
                severityLevel: SeverityLevel.Verbose
            }, {
                properties: properties,
            });
        }
    };
    AppInsightsWebLogger.prototype._createProperties = function (obj) {
        var properties = Object.entries(obj).reduce(function (agg, _a) {
            var key = _a[0], value = _a[1];
            if (value === undefined) {
                agg[key] = '<undefined>';
            }
            else {
                if (value === null) {
                    agg[key] = '<null>';
                }
                else {
                    agg[key] = value.toString();
                }
            }
            return agg;
        }, {});
        return properties;
    };
    AppInsightsWebLogger._appInsights = null;
    return AppInsightsWebLogger;
}());
export { AppInsightsWebLogger };
//# sourceMappingURL=app-insights-logger-service.js.map